// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.font_size {
  font-size: 12px !important;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
}

.link_Nonhighlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  margin-right: 1%;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  max-width: 92%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.primary_card {
  border-left: 4px solid #007bff;
}

.healing_card {
  border-left: 4px solid #f5a700;
}

.ignored_card {
  border-left: 4px solid rgba(128, 128, 128, 0.6901960784);
}

.inprogress_card {
  border-left: 4px solid #ff8900;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

.pin-icon, .pinned-icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 18px;
  transition: transform 0.2s, color 0.2s;
}

.pin-icon {
  color: #d9d3d3;
}

.pin-icon:hover {
  transform: scale(1.2);
  color: #ffc107;
}

.pinned-icon {
  color: #17a0b4;
  transform: rotate(15deg);
}

.pinned-icon:hover {
  transform: rotate(15deg) scale(1.2);
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
}

.pipeline_label {
  float: left;
  padding-right: 11%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 100%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 30px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 100%;
}

.btnsdiv {
  padding-left: 16%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 100%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 100%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.messageiot .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiot {
  height: 80vh;
  width: 88vw;
  top: 16% !important;
  left: 12%;
}

::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

/* Minimal spacing fix: Download (pull-center at left 50%) and View (view-btn-details at left 57%)
   are both absolutely positioned, so View starts before Download ends and they appear attached.
   Offset View slightly right to add visible gap without changing Download position or button actions. */
::ng-deep.messageiot .modal-dialog .modal-content .modal-footer .view-btn-details {
  left: calc(57% + 24px) !important;
}

::ng-deep.messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  height: 85% !important;
  min-width: 0 !important;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

.messagestatus {
  position: relative;
  top: -3px;
}

.transaction_feild {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.transaction_feild2 {
  float: left;
  font-size: 12px !important;
  height: 5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.inIcon {
  position: relative;
  top: -15%;
}

::ng-deep.mirth_transaction_style .mat-content {
  display: block !important;
}

::ng-deep.mirth_transaction_style {
  transform: none !important;
  height: 65vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

::ng-deep.Mode_Boot .modal-dialog {
  max-width: 97% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.Mode_Boot {
  font-family: montserrat;
  font-size: 12px;
  height: 80vh;
  width: 88vw;
  left: 12%;
  top: 16.5% !important;
}
::ng-deep.Mode_Boot strong {
  font-weight: 600 !important;
}

.fieldstyle {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
  border: transparent;
  width: 98% !important;
  min-height: 50px !important;
  max-height: 50px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background-color: white !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix {
  padding-inline: 5px;
  padding-block: 1px;
  padding-top: 0px !important;
  min-height: 40px !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list {
  display: inline-block;
}

.examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper {
  padding-top: 15px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-mdc-form-field-infix .mat-chip-list-wrapper {
  padding-top: 0px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {
  margin-top: -1% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

.matchipinputfield input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.matchipinputfield2 input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.message_feild2 {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  float: left;
  height: 5vh;
  font-size: 12px !important;
}

.textFeid {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  height: 16.5vh;
  font-size: 12px !important;
}

.message_feild1 {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.message_feild3 {
  float: left;
  font-size: 12px !important;
  height: 15.8vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.card_HeightExp {
  max-height: 34vh;
  min-height: 34vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.card_HeightCol {
  max-height: 57vh;
  min-height: 57vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.view-btn-details {
  position: absolute;
  left: 57%;
  width: 84px;
  /* margin-left: 10px; — insufficient for absolute-positioned Download/View overlap; see ::ng-deep.messageiot footer rule above */
}

::ng-deep .PopupScreen .modal-dialog {
  max-width: 80% !important;
  max-height: 50px !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

::ng-deep.myCustomModalViewfile .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

/* Put space after ::ng-deep */
::ng-deep .pinMessageModalClass .modal-dialog {
  max-width: 462px !important;
  width: 462px !important;
  margin: auto !important;
  min-height: calc(100% - 1rem);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Keep modal-content full width */
::ng-deep .pinMessageModalClass .modal-content {
  width: 100% !important;
  margin: 0 auto !important;
}

::ng-deep.pinMessageModalClass textarea.transaction_feild {
  min-height: 60px !important;
  height: 60px !important;
  resize: vertical;
}

::ng-deep.pinMessageModalClass input.transaction_feild {
  height: 35px !important;
  padding: 6px 12px !important;
}

::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox {
  width: 14px;
  height: 14px;
  padding-right: 6px;
  bottom: 4px;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-form-field > label {
  padding-right: 10px;
}

::ng-deep.msgrep.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

.copylabel {
  position: relative;
  bottom: 8px;
}

::ng-deep.messageioteditor .editor-container .monaco-editor {
  width: 100% !important;
  height: 340px !important;
}
::ng-deep.messageioteditor .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
  height: 340px !important;
}
::ng-deep.messageioteditor .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  width: 85% !important;
  height: 340px !important;
}

::ng-deep.messageioteditormax .editor-container .monaco-editor {
  width: 100% !important;
  height: 340px !important;
}
::ng-deep.messageioteditormax .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
  height: 340px !important;
}
::ng-deep.messageioteditormax .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  width: 92% !important;
}

::ng-deep.viewstagesmsg .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstagesmsg {
  height: 77vh;
  width: 88vw;
  left: 12%;
  top: 16% !important;
  font-family: "Montserrat", sans-serif;
  font-size: 11px;
}
::ng-deep.viewstagesmsg strong {
  font-weight: 600 !important;
}

.button-container {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  padding-bottom: 0px !important;
  scrollbar-width: thin;
  min-height: 5vh;
  max-height: 8vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  padding: 10px;
  width: 100%;
}

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #4caf50;
  border: none;
  cursor: pointer;
  position: relative;
  padding-bottom: 2px;
  transition: transform 0.2s;
}

.icons_list_style {
  background-color: transparent;
}

.icons_list_style_active {
  background-color: transparent;
}

.icon-button.icons_list_style_active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #00bcd4;
  border-radius: 5px;
}

.icon-button.icons_list_style_active:has(.stage-transform-failed-memory)::after {
  left: 3px;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mirthsuc {
  font-weight: normal;
  display: inline;
  margin-left: 2px;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-sm-4 {
  padding: 10px;
}

.msg-meta-col {
  position: relative;
  min-width: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.msg-meta-prefix {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.msg-meta-icons {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.msg-meta-date {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding-left: 72px;
  color: #17a2b8;
  text-align: left;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}

.msg-meta-col--child {
  padding-left: 33px;
}

.msg-meta-col--child .msg-meta-date {
  padding-left: 52px;
}

.msg-meta-col--child .msg-meta-icons .child-envelope-icon {
  position: relative;
  top: 8px;
  margin-right: 8px;
}

.div-message-attributes {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  color: black;
}

.mt-minus-3 {
  margin-top: -2vh;
}

.icon-style {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-top: -9px;
  margin-right: 16px;
  font-size: 27px;
}

.icon-styles {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: -12px;
  margin-right: 16px;
  height: 20px;
  width: 20px;
}

.icon-ack {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: -6px;
  margin-right: 15px;
  height: 25px;
  width: 22px;
}

.icon-hold {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: 3px;
  margin-right: 16px;
  font-size: 21px;
  width: 20px;
}

.clickable-div {
  cursor: pointer;
}

.clickable-div button,
.clickable-div mat-icon,
.clickable-div i,
.clickable-div img,
.clickable-div svg,
.clickable-div td {
  cursor: pointer !important;
}

.redirectlink {
  white-space: nowrap;
  position: relative;
  z-index: 1000;
  color: #4b86b2;
}

.redirectlink:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  z-index: 1000;
}

.childexpcard {
  background-color: #f9f9f9;
  margin-bottom: 0;
  padding-top: 5px;
  min-height: 13vh;
  max-height: 23vh;
  overflow-x: hidden;
  overflow-y: auto;
}

::ng-deep.main_page_paginator .mat-mdc-paginator-container {
  min-height: 40px !important;
  max-height: 40px !important;
}

.hl7-btn {
  background-color: #17a0b4;
  color: white;
  height: 24px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 8px;
}

.hl7-btn:hover {
  background-color: #138b9a; /* darker shade on hover */
}

.hl7-icon {
  font-size: medium;
  position: relative;
  left: 2px;
  margin-right: 4px;
}

.copylabel {
  cursor: pointer;
}

::ng-deep.entityModalClass {
  height: 82vh !important;
  top: 16% !important;
  width: 89vw !important;
  left: 11% !important;
}
::ng-deep.entityModalClass .modal-dialog {
  margin-block: 0px !important;
}

::ng-deep.myCustomModalClass {
  height: 82vh;
  top: 16%;
  width: 89vw !important;
  left: 11%;
}
::ng-deep.myCustomModalClass .modal-dialog {
  margin-block: 0px !important;
}

::ng-deep.myCustomModalClassfailedstage {
  height: 82vh;
  top: 16%;
  width: 89vw !important;
  left: 11%;
}
::ng-deep.myCustomModalClassfailedstage .modal-dialog {
  margin: 0px !important;
  left: 2% !important;
}
::ng-deep.myCustomModalClassfailedstage .modal-dialog .modal-content {
  width: 85vw !important;
}

::ng-deep.TraceLogsModalClass {
  height: 80vh;
  width: 85vw;
  left: 15%;
  top: 16%;
}
::ng-deep.TraceLogsModalClass .modal-dialog {
  margin: 0;
  left: 2%;
}
::ng-deep.TraceLogsModalClass .modal-dialog .modal-content {
  height: 78vh !important;
  width: 85vw !important;
}

.messages-export-menu-wrap {
  display: inline-block;
  vertical-align: middle;
}

.messages-export-dropdown-panel {
  position: fixed;
  transform: translateX(-100%);
  z-index: 1100;
  width: 300px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 4px 0;
}
.messages-export-dropdown-panel.bulk-download-dropdown-panel {
  width: 320px;
}
.messages-export-dropdown-panel .bulk-download-chevron {
  flex-shrink: 0;
  font-size: 11px;
  margin-left: auto;
  opacity: 0.7;
}
.messages-export-dropdown-panel .export-range-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  min-height: 40px;
  padding: 0 16px;
  cursor: default;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 4px;
  white-space: nowrap;
}
.messages-export-dropdown-panel .export-range-label {
  color: #17a2b8;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
  flex-shrink: 0;
}
.messages-export-dropdown-panel .export-range-controls {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 12px;
}
.messages-export-dropdown-panel .export-range-value {
  color: #212529;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
  width: 96px;
  text-align: right;
  margin-right: 2px;
}
.messages-export-dropdown-panel .export-range-nav-btn {
  background: transparent;
  border: none;
  color: #17a2b8;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  flex-shrink: 0;
  width: 20px;
  text-align: center;
}
.messages-export-dropdown-panel .export-range-nav-btn:disabled {
  color: #c0c0c0;
  cursor: not-allowed;
}
.messages-export-dropdown-panel .export-range-nav-btn:not(:disabled):hover {
  color: #138496;
}

.messages-export-dropdown-item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  padding: 8px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  white-space: nowrap;
}
.messages-export-dropdown-item:hover, .messages-export-dropdown-item:focus {
  background: rgba(0, 0, 0, 0.04);
  outline: none;
}
.messages-export-dropdown-item.bulk-download-menu-row {
  align-items: center;
  display: flex;
}

.bulk-download-export-section {
  padding: 4px 0 8px;
}

.bulk-download-export-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 4px 0 8px;
}

.bulk-download-export-title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: 600;
  gap: 8px;
  justify-content: space-between;
  padding: 0 16px 6px;
}

.bulk-download-count-badge {
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
}

.bulk-download-count--ok {
  background: #e8f5e9;
  color: #2e7d32;
}

.bulk-download-count--none {
  background: #f5f5f5;
  color: #757575;
}

.bulk-download-count--over {
  background: #ffebee;
  color: #c62828;
}

.bulk-download-limit-warning {
  color: #c62828;
  font-size: 12px;
  font-weight: 500;
  margin: 0 16px 8px;
}

.bulk-download-type-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 16px 8px;
}

.bulk-download-pill {
  background: #fff;
  border: 1px solid #009688;
  border-radius: 16px;
  color: #009688;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  padding: 5px 14px;
  transition: background 0.15s ease, color 0.15s ease;
}
.bulk-download-pill:hover {
  background: rgba(0, 150, 136, 0.08);
}
.bulk-download-pill:focus {
  outline: none;
}

.bulk-download-pill--active {
  background: #009688;
  color: #fff;
}
.bulk-download-pill--active:hover {
  background: #00796b;
}

.bulk-download-export-checkboxes {
  padding: 0 16px 4px;
  font-size: 13px;
}

.bulk-download-export-action {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/hubmessages/hubmessages.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,0BAAA;AAAF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAEF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAEF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAGF;;AADA;EACE,yBAAA;AAIF;;AAFA;EACE,yBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAKF;;AAFA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAKF;;AAFA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,iBAAA;AAIF;;AAFA;EACE,8BAAA;AAKF;;AAHA;EACE,8BAAA;AAMF;;AAJA;EACE,mBAAA;AAOF;;AALA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAQF;;AANA;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AASF;;AAPA;EACE,8BAAA;AAUF;;AARA;EACE,8BAAA;AAWF;;AATA;EACE,8BAAA;AAYF;;AAVA;EACE,wDAAA;AAaF;;AAXA;EACE,8BAAA;AAcF;;AAZA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAeF;;AAbA;EACE,iEAAA;AAgBF;;AAdA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAiBF;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,qBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,cAAA;EACA,wBAAA;AAiBF;;AAdA;EACE,mCAAA;AAiBF;;AAdA;EACE,eAAA;EACA,eAAA;EACA,eAAA;AAiBF;;AAdA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAiBF;;AAfA;EACE,WAAA;EACA,WAAA;AAkBF;;AAfA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAkBF;;AAhBA;EACE,WAAA;EACA,WAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,WAAA;AAoBF;;AAjBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,WAAA;AAqBF;;AAnBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAsBF;;AApBA;EACE,WAAA;EACA,WAAA;AAuBF;;AApBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAuBF;;AArBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAwBF;;AArBA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAwBF;;AAtBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAyBF;;AAvBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA0BF;;AAvBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA0BF;;AAxBA;EACE,WAAA;EACA,WAAA;AA2BF;;AAxBA;EACE,iBAAA;AA2BF;;AAxBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA2BF;EAxBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EA0BF;EAxBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EA0BF;EAxBA;IACE,WAAA;IACA,WAAA;EA0BF;EAvBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAyBF;EAtBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAwBF;EAtBA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAwBF;EAtBA;IACE,0BAAA;EAwBF;EAtBA;IACE,cAAA;EAwBF;EAtBA;IACE,cAAA;EAwBF;EArBE;IACE,qBAAA;EAuBJ;AACF;AAnBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAqBF;EAlBA;IACE,WAAA;IACA,WAAA;EAoBF;EAlBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAoBF;EAlBA;IACE,WAAA;IACA,WAAA;EAoBF;EAlBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAoBF;EAlBA;IACE,WAAA;IACA,WAAA;EAoBF;EAlBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAoBF;EAlBA;IACE,WAAA;IACA,WAAA;EAoBF;EAjBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAmBF;EAjBA;IACE,WAAA;IACA,WAAA;EAmBF;EAjBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAmBF;EAjBA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAmBF;EAhBA;IACE,8BAAA;EAkBF;EAfA;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAiBF;EAfA;IACE,0BAAA;EAiBF;EAfA;IACE,cAAA;EAiBF;EAfA;IACE,cAAA;EAiBF;EAdE;IACE,qBAAA;EAgBJ;AACF;AAVA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AAYF;;AARA;EACE,sBAAA;AAWF;;AARA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAWF;;AARA;EACE,YAAA;AAWF;;AATA;EACE,UAAA;AAYF;;AATA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAWF;;AARA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAWF;;AATA;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AAYJ;;AATA;EACE,yBAAA;EACA,0BAAA;EACE,8BAAA;EACA,oCAAA;EAEA,wCAAA;EACA,yDAAA;EACA,wDAAA;AAWJ;;AARA;;wGAAA;AAGA;EACE,iCAAA;AAWF;;AAPA;EACE,2BAAA;EACE,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAUJ;;AAPA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAUF;;AAPA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AASF;;AANA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAQF;;AALA;EACE,kBAAA;EACE,SAAA;AAQJ;;AANA;EACE,WAAA;EACA,0BC/iBS;EDgjBT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AASJ;;AAPA;EACE,WAAA;EACA,0BCvjBS;EDwjBT,WAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AAUJ;;AA6BA;EACE,kBAAA;EACA,SAAA;AA1BF;;AA8BA;EACE,yBAAA;AA3BF;;AA6BA;EACE,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;AA1BF;;AA4BA;EACE,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;AAzBF;AA0BE;EACE,2BAAA;AAxBJ;;AA2BA;EACE,yCAAA;EAAwC,6BAAA;EAAkC,mBAAA;EAC1E,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;AAtBF;;AAwBE;EACE,mBAAA;EACE,kBAAA;EACA,2BAAA;EACA,2BAAA;AArBN;;AAsBE;EAEG,qBAAA;AApBL;;AAuBE;EACI,yCAAA;EACA,iBAAA;AApBN;;AAsBE;EACE,4BAAA;EACA,WAAA;AAnBJ;;AAqBE;EACE,2BAAA;EACA,WAAA;AAlBJ;;AAoBE;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAjBL;;AAmBE;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAhBL;;AAkBA;EACE,YAAA;EACA,WAAA;EACF,eAAA;AAfA;;AAiBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAdF;;AAgBA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0BC7rBO;ADgrBX;;AAeA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,cAAA;EACA,0BCpsBO;ADwrBX;;AAeA;EACE,WAAA;EACA,0BCzsBS;ED0sBT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AAZJ;;AAcA;EACE,WAAA;EACA,0BCjtBS;EDktBT,cAAA;EACA,kBAAA;EACA,oDAAA;EACA,WAAA;AAXF;;AAaA;EAEE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAXF;;AAaA;EAEE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAXF;;AAaA;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gIAAA;AAXF;;AAaA;EACE,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAT3B;;AAWA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAP3B;;AAYA,8BAAA;AACA;EACE,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AATF;;AAYA,kCAAA;AACA;EACE,sBAAA;EACA,yBAAA;AATF;;AAYA;EACE,2BAAA;EACA,uBAAA;EACA,gBAAA;AATF;;AAYA;EACE,uBAAA;EACA,4BAAA;AATF;;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAZJ;AAaI;EACE,gCClyBM;EDmyBN,oCCnyBM;ADwxBZ;AAaI;EACE,YAAA;AAXN;AAcE;EACE,YAAA;EACA,WAAA;AAZJ;AAcE;EACE,mBAAA;AAZJ;;AAgBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAbF;AAcE;EACE,WAAA;EACA,YAAA;AAZJ;AAaI;EACE,gCC5zBM;ED6zBN,oCC7zBM;ADkzBZ;AAaI;EACE,YAAA;AAXN;AAcE;EACE,YAAA;EACA,WAAA;AAZJ;;AAgBE;EACE,WAAA;EACA,YAAA;AAbJ;AAcI;EACE,gCC70BM;ED80BN,oCC90BM;ADk0BZ;AAcI;EACE,YAAA;AAZN;AAeE;EACE,uBAAA;EACA,sBAAA;AAbJ;;AAgBA;EACE,kBAAA;EACE,WAAA;AAbJ;;AAiBE;EACE,sBAAA;EACA,wBAAA;AAdJ;AAeI;EACE,sBAAA;EACA,wBAAA;AAbN;AAcM;EACE,qBAAA;EACA,wBAAA;AAZR;;AAkBE;EACE,sBAAA;EACA,wBAAA;AAfJ;AAgBI;EACE,sBAAA;EACA,wBAAA;AAdN;AAeM;EACE,qBAAA;AAbR;;AAkBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAfF;;AAiBA;EACI,YAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACF,qCAAA;EACA,eAAA;AAdF;AAgBE;EACE,2BAAA;AAdJ;;AAiBA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AAdF;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,SAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAdF;;AAgBA;EACE,gBAAA;AAbF;;AAiBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAdF;;AAkBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAfF;;AAkBA;EACE,eAAA;AAfF;;AAkBA;;;;;;EAME,0BAAA;AAfF;;AAiBA;EACE,mBAAA;EAAsB,kBAAA;EAAoB,aAAA;EAC1C,cAAA;AAZF;;AAcA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EAAoB,aAAA;AAVxB;;AAYA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AATF;;AAYE;EACE,2BAAA;EACA,2BAAA;AATJ;;AAYA;EACE,yBAAA;EAA2B,YAAA;EAAc,YAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,kBAAA;EAAmB,QAAA;AAH3H;;AAMA;EACE,yBAAA,EAAA,0BAAA;AAHF;;AAMA;EACE,iBAAA;EAAmB,kBAAA;EAAmB,SAAA;EAAW,iBAAA;AAAnD;;AAGA;EACE,eAAA;AAAF;;AAEA;EACE,uBAAA;EAAwB,mBAAA;EAAoB,sBAAA;EAAuB,oBAAA;AAIrE;AAHE;EACE,4BAAA;AAKJ;;AAFA;EACE,YAAA;EACA,QAAA;EACA,sBAAA;EACA,SAAA;AAKF;AAJE;EACE,4BAAA;AAMJ;;AAHA;EACE,YAAA;EACA,QAAA;EACA,sBAAA;EACA,SAAA;AAMF;AALE;EACE,sBAAA;EACA,mBAAA;AAOJ;AANI;EACE,sBAAA;AAQN;;AAJA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AAOF;AANE;EACE,SAAA;EACA,QAAA;AAQJ;AAPE;EACE,uBAAA;EACA,sBAAA;AASJ;;AAJA;EACE,qBAAA;EACA,sBAAA;AAOF;;AAJA;EACE,eAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;AAOF;AALE;EACE,YAAA;AAOJ;AAJE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAMJ;AAHE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,4CAAA;EACA,kBAAA;EACA,mBAAA;AAKJ;AAFE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAIJ;AADE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAGJ;AAAE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAEJ;AACE;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AACJ;AACI;EACE,cAAA;EACA,mBAAA;AACN;AAEI;EACE,cAAA;AAAN;;AAKA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;AAFF;AAIE;EAEE,+BAAA;EACA,aAAA;AAHJ;AAME;EACE,mBAAA;EACA,aAAA;AAJJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,yCAAA;EACA,iBAAA;AANF;;AASA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;AANF;;AASA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;AANF;;AASA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AANF;;AAUA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mDAAA;AAPF;AASE;EACE,mCAAA;AAPJ;AAUE;EACE,aAAA;AARJ;;AAYA;EACE,mBAAA;EACA,WAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,mBAAA;EACA,eAAA;AAVF;;AAaA;EACE,gBAAA;AAVF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.font_size{\r\n  font-size: 12px !important;\r\n}\r\n\r\n\r\n.ng-autocompleteroutr {\r\n  width: 370px;\r\n}\r\n.search_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.reset_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n}\r\n.link_Nonhighlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.link_highlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  margin-right: 1%;\r\n}\r\n.link_highlight:hover{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.iconCheck {\r\n  font-size: 12px;\r\n  position: relative;\r\n  top: -20%;\r\n  margin-left: -3px;\r\n}\r\n.doller {\r\n  position: absolute;\r\n  top: -11px;\r\n  left: 15%;\r\n}\r\n.textCenter {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.text-success {\r\n  color: #5dd077 !important;\r\n}\r\n.text-danger {\r\n  color: #da606c !important;\r\n}\r\n\r\n.gui_ellipsis {\r\n  font-weight: 600;\r\n  max-width: 92%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n}\r\n\r\n.pipeline_ellipsis {\r\n  max-width: 89%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  position: relative;\r\n  top: 8%;\r\n  left: 1%;\r\n  padding-right: 1%;\r\n}\r\n\r\n.trans_ellipsis {\r\n  max-width: 74%;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  // top: 11%;\r\n  padding-right: 1%;\r\n}\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.iconPointer:hover {\r\n  pointer-events: all;\r\n}\r\n.arrow_source {\r\n  left: 5%;\r\n  width: 97%;\r\n  height: 2px;\r\n  background-color: grey;\r\n  position: relative;\r\n  top: 36%;\r\n}\r\n.arr_chev {\r\n  position: relative;\r\n  text-align: right !important;\r\n  right: -98%;\r\n  color: grey;\r\n  top: -9px;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.primary_card {\r\n  border-left: 4px solid #007bff;\r\n}\r\n.healing_card {\r\n  border-left: 4px solid  #f5a700;\r\n}\r\n.ignored_card{\r\n  border-left: 4px solid #808080b0;\r\n}\r\n.inprogress_card{\r\n  border-left: 4px solid #ff8900;\r\n}\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n.pin-icon, .pinned-icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  transition: transform 0.2s, color 0.2s;\r\n}\r\n\r\n.pin-icon {\r\n  color: #d9d3d3;\r\n}\r\n\r\n.pin-icon:hover {\r\n  transform: scale(1.2);\r\n  color: #ffc107;\r\n}\r\n\r\n.pinned-icon {\r\n  color: #17a0b4;\r\n  transform: rotate(15deg);\r\n}\r\n\r\n.pinned-icon:hover {\r\n  transform: rotate(15deg) scale(1.2);\r\n}\r\n\r\n.copy_icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n.pipeline_label {\r\n  float: left;\r\n  padding-right: 11%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.pipeline_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.source_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.source_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.target_label {\r\n  float: left;\r\n  padding-right: 13%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.target_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 7%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.processor_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.message_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.transaction_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n\r\n.message_type_feild {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: -6px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type {\r\n  width: 100%;\r\n  height: 30px;\r\n  position: relative;\r\n}\r\n\r\n.messagefield_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.messagefield_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.btnsdiv {\r\n  padding-left: 16%;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .message_type {\r\n    width: 53%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 85%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 65%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 6%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_type {\r\n    width: 86%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n\r\n  .reset_btn {\r\n    padding-inline: 13% !important;\r\n  }\r\n\r\n  .gui_ellipsis {\r\n    font-weight: 600;\r\n    width: 65%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 81%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 52%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.rightalign {\r\n  float: right;\r\n  padding-right: 60px;\r\n  padding-top: 10px;\r\n}\r\n\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.text-green{\r\n  color:green\r\n}\r\n.text-red{\r\n  color:red;\r\n}\r\n\r\n::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170% !important;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiot{\r\n    height: 80vh;\r\n    width: 88vw;\r\n    top: 16% !important;\r\n    left: 12%;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer{\r\n  display: unset!important;\r\n  flex-wrap: wrap!important;\r\n    align-items: center!important;\r\n    justify-content: flex-end!important;\r\n\r\n    border-top: 1px solid #dee2e6!important;\r\n    border-bottom-right-radius: calc(0.3rem - 1px)!important;\r\n    border-bottom-left-radius: calc(0.3rem - 1px)!important;\r\n}\r\n\r\n/* Minimal spacing fix: Download (pull-center at left 50%) and View (view-btn-details at left 57%)\r\n   are both absolutely positioned, so View starts before Download ends and they appear attached.\r\n   Offset View slightly right to add visible gap without changing Download position or button actions. */\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer .view-btn-details {\r\n  left: calc(57% + 24px) !important;\r\n}\r\n\r\n\r\n::ng-deep.messageioteditor .editor-container{\r\n  overflow: hidden!important;\r\n    position: relative!important;\r\n    display: table!important;\r\n    width: 100%!important;\r\n    height: 85%!important;\r\n    min-width: 0!important;\r\n}\r\n\r\n.date_control_style{\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n  // padding-block: 3%;\r\n}\r\n.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170%;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n.messagestatus{\r\n  position: relative;\r\n    top: -3px;\r\n}\r\n.transaction_feild{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n.transaction_feild2{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n// .hubmessageList{\r\n//   ::ng-deep .mat-ink-bar {\r\n//     background-color: rgba(0, 0, 0, 0) !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label {\r\n//     // background-color: rgb(238, 180, 23) !important;\r\n//     height: 30px  !important;\r\n//     opacity:unset !important;\r\n//     padding-inline: 1% !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label.mat-tab-label-active {\r\n//     min-width: 25px !important;\r\n//     padding: 5px 10px;\r\n//       background-color: #12127c;\r\n//       color: white;\r\n//       font-weight: 700;\r\n//       opacity: unset;\r\n//       border-top-left-radius: 5px;\r\n//       border-top-right-radius: 5px;\r\n//   }\r\n//   ::ng-deep .mat-tab-label {\r\n//     min-width: 25px !important;\r\n//     padding: 5px;\r\n//     background-color: transparent;\r\n//     color: black;\r\n//     font-weight: 700;\r\n//   }\r\n// }\r\n\r\n// ::ng-deep .mat-tab-body-content {\r\n//   overflow-x: hidden !important;\r\n// }\r\n\r\n\r\n\r\n.inIcon{\r\n  position: relative;\r\n  top:-15%;\r\n}\r\n\r\n\r\n::ng-deep.mirth_transaction_style .mat-content{\r\n  display: block !important;\r\n}\r\n::ng-deep.mirth_transaction_style{\r\n  transform: none !important;\r\n  height: 65vh !important;\r\n  overflow-y: auto !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n::ng-deep.Mode_Boot .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 100% !important;\r\n  height: 100% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.Mode_Boot {\r\n  font-family: montserrat;\r\n  font-size: 12px;\r\n  height: 80vh;\r\n  width: 88vw;\r\n  left: 12%;\r\n  top: 16.5% !important;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n.fieldstyle{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%); border-radius: 5px !important;    border: transparent;\r\n  width:98% !important;\r\n  min-height: 50px !important;\r\n  max-height: 50px !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  background-color: white !important;\r\n}\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix  {\r\n    padding-inline: 5px ;\r\n      padding-block: 1px ;\r\n      padding-top: 0px !important;\r\n      min-height: 40px !important ; }\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list\r\n  {\r\n     display: inline-block;\r\n    }\r\n\r\n  .examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n      transform: translateY(-1.1em) scale(.75);\r\n      width: 133.33333%;\r\n  }\r\n  ::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper{\r\n    padding-top: 15px !important;\r\n    float: left;\r\n  }\r\n  ::ng-deep.examplechiplist2 .mat-mdc-form-field-infix .mat-chip-list-wrapper{\r\n    padding-top: 0px !important;\r\n    float: left;\r\n  }\r\n  ::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {\r\n    margin-top: -1% !important;\r\n    margin-left: 2% !important;\r\n     padding-bottom: 0px !important;\r\n  }\r\n  ::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {\r\n    margin-top: -3% !important;\r\n    margin-left: 2% !important;\r\n     padding-bottom: 0px !important;\r\n  }\r\n.matchipinputfield input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\nflex: 1 0 150px;\r\n }\r\n.matchipinputfield2 input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\n  flex: 1 0 150px;\r\n}\r\n.message_feild2{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    float: left;\r\n    height: 5vh;\r\n    font-size: $fontsize;\r\n}\r\n.textFeid{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    height: 16.5vh;\r\n    font-size: $fontsize\r\n}\r\n\r\n.message_feild1{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n.message_feild3{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 15.8vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  width: 100%;\r\n}\r\n.card_HeightExp\r\n{\r\n  max-height:34vh;\r\n  min-height:34vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n.card_HeightCol\r\n{\r\n  max-height: 57vh;\r\n  min-height:57vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n.view-btn-details\r\n{\r\n  position: absolute;\r\n  left: 57%;\r\n  width: 84px;\r\n  /* margin-left: 10px; — insufficient for absolute-positioned Download/View overlap; see ::ng-deep.messageiot footer rule above */\r\n}\r\n::ng-deep .PopupScreen .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 50px !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n::ng-deep.myCustomModalViewfile .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n\r\n\r\n\r\n/* Put space after ::ng-deep */\r\n::ng-deep .pinMessageModalClass .modal-dialog {\r\n  max-width: 462px !important;\r\n  width: 462px !important;\r\n  margin: auto !important;\r\n  min-height: calc(100% - 1rem);\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n/* Keep modal-content full width */\r\n::ng-deep .pinMessageModalClass .modal-content {\r\n  width: 100% !important;\r\n  margin: 0 auto !important;\r\n}\r\n\r\n::ng-deep.pinMessageModalClass textarea.transaction_feild {\r\n  min-height: 60px !important;\r\n  height: 60px !important;\r\n  resize: vertical;\r\n}\r\n\r\n::ng-deep.pinMessageModalClass input.transaction_feild {\r\n  height: 35px !important;\r\n  padding: 6px 12px !important;\r\n}\r\n\r\n\r\n\r\n::ng-deep.archivecheck.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 14px;\r\n    height: 14px;\r\n    padding-right: 6px;\r\n    bottom: 4px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n  .mdc-form-field>label {\r\n    padding-right: 10px;\r\n  }\r\n}\r\n\r\n::ng-deep.msgrep.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 3%;\r\n  bottom: 9%;\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n.copylabel{\r\n  position: relative;\r\n    bottom: 8px;\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container{\r\n  .monaco-editor{\r\n    width: 100% !important;\r\n    height: 340px !important;\r\n    .overflow-guard{\r\n      width: 100% !important;\r\n      height: 340px !important;\r\n      .monaco-scrollable-element.editor-scrollable{\r\n        width: 85% !important;\r\n        height: 340px !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep.messageioteditormax .editor-container{\r\n  .monaco-editor{\r\n    width: 100% !important;\r\n    height: 340px !important;\r\n    .overflow-guard{\r\n      width: 100% !important;\r\n      height: 340px !important;\r\n      .monaco-scrollable-element.editor-scrollable{\r\n        width: 92% !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep.viewstagesmsg .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstagesmsg {\r\n    height: 77vh;\r\n    width: 88vw;\r\n    left: 12%;\r\n    top: 16% !important;\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 11px;\r\n\r\n  strong {\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n.button-container {\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  flex-wrap: nowrap;\r\n  padding-bottom: 0px !important;\r\n  scrollbar-width: thin;\r\n  min-height: 5vh;\r\n  max-height: 8vh;\r\n  display: flex; \r\n  justify-content: flex-start; \r\n  align-items: center; \r\n  gap: 15px; \r\n  padding: 10px; \r\n  width: 100%; \r\n}\r\n\r\n.icon-button {\r\n  display: flex; \r\n  align-items: center; \r\n  justify-content: center; \r\n  background-color: transparent; \r\n  color: #4caf50; \r\n  border: none; \r\n  cursor: pointer; \r\n  position: relative;\r\n  padding-bottom: 2px;\r\n  transition: transform 0.2s; \r\n}\r\n\r\n.icons_list_style {\r\n  background-color: transparent; \r\n}\r\n\r\n.icons_list_style_active {\r\n  background-color: transparent; \r\n}\r\n\r\n.icon-button.icons_list_style_active::after {\r\n  content: \"\"; \r\n  position: absolute; \r\n  bottom: 0; \r\n  left: 0; \r\n  right: 0; \r\n  height: 3px; \r\n  background-color: #00bcd4; \r\n  border-radius: 5px; \r\n}\r\n\r\n.icon-button.icons_list_style_active:has(.stage-transform-failed-memory)::after {\r\n  left: 3px;\r\n}\r\n\r\n.text-truncate {\r\n  white-space: nowrap; \r\n  overflow: hidden;\r\n  text-overflow: ellipsis; \r\n}\r\n\r\n.mirthsuc {\r\n  font-weight: normal; \r\n  display: inline; \r\n  margin-left: 2px;\r\n  max-width: 220px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.col-sm-4 {\r\n  padding: 10px; \r\n}\r\n\r\n.msg-meta-col {\r\n  position: relative;\r\n  min-width: 0;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.msg-meta-prefix {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.msg-meta-icons {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin-left: 4px;\r\n}\r\n\r\n.msg-meta-date {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 72px;\r\n  color: #17a2b8;\r\n  text-align: left;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.msg-meta-col--child {\r\n  padding-left: 33px;\r\n}\r\n\r\n.msg-meta-col--child .msg-meta-date {\r\n  padding-left: 52px;\r\n}\r\n\r\n.msg-meta-col--child .msg-meta-icons .child-envelope-icon {\r\n  position: relative;\r\n  top: 8px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.div-message-attributes {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  width: 100%;\r\n  color: black; \r\n}\r\n.mt-minus-3 {\r\n  margin-top: -2vh;\r\n}\r\n\r\n\r\n.icon-style {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-top: -9px;\r\n  margin-right: 16px;\r\n  font-size: 27px;\r\n}\r\n\r\n\r\n.icon-styles {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: -12px;\r\n  margin-right: 16px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.icon-ack {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: -6px; \r\n  margin-right: 15px;\r\n  height: 25px;\r\n  width: 22px;\r\n}\r\n\r\n.icon-hold {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: 3px;\r\n  margin-right: 16px;\r\n  font-size: 21px;\r\n  width: 20px;\r\n}\r\n\r\n.clickable-div {\r\n  cursor: pointer; \r\n}\r\n\r\n.clickable-div button,\r\n.clickable-div mat-icon,\r\n.clickable-div i,\r\n.clickable-div img,\r\n.clickable-div svg,\r\n.clickable-div td {\r\n  cursor: pointer !important;\r\n}\r\n.redirectlink{\r\n  white-space: nowrap;  position: relative; z-index: 1000;\r\n  color: #4b86b2;\r\n}\r\n.redirectlink:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    position: relative; z-index: 1000;\r\n}\r\n.childexpcard{\r\n  background-color:#f9f9f9; \r\n  margin-bottom: 0; \r\n  padding-top: 5px;\r\n  min-height: 13vh;\r\n  max-height: 23vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n::ng-deep.main_page_paginator{\r\n  .mat-mdc-paginator-container{\r\n    min-height: 40px !important;\r\n    max-height: 40px !important;\r\n  }\r\n}\r\n.hl7-btn {\r\n  background-color: #17a0b4; color: white; height: 24px;  align-items: center; justify-content: center; position:absolute; top: 8px;\r\n}\r\n\r\n.hl7-btn:hover {\r\n  background-color: #138b9a;  /* darker shade on hover */\r\n}\r\n\r\n.hl7-icon {\r\n  font-size: medium ;position: relative;left: 2px; margin-right: 4px\r\n}\r\n\r\n.copylabel {\r\n  cursor: pointer;\r\n}\r\n::ng-deep.entityModalClass{\r\n  height: 82vh !important;top: 16% !important;width: 89vw !important;left: 11% !important;\r\n  .modal-dialog{\r\n    margin-block: 0px !important;\r\n  }\r\n}\r\n::ng-deep.myCustomModalClass{\r\n  height: 82vh;\r\n  top: 16%;\r\n  width: 89vw !important;\r\n  left: 11%;\r\n  .modal-dialog{\r\n    margin-block: 0px !important;\r\n  }\r\n}\r\n::ng-deep.myCustomModalClassfailedstage{\r\n  height: 82vh;\r\n  top: 16%;\r\n  width: 89vw !important;\r\n  left: 11%;\r\n  .modal-dialog{\r\n    margin: 0px !important;\r\n    left:2% !important;\r\n    .modal-content{\r\n      width: 85vw !important;\r\n    }\r\n  }\r\n}\r\n::ng-deep.TraceLogsModalClass{\r\n  height: 80vh;\r\n  width: 85vw;\r\n  left: 15%;\r\n  top: 16%;\r\n  .modal-dialog{\r\n    margin: 0;\r\n    left: 2%;\r\n  .modal-content{\r\n    height: 78vh !important;\r\n    width: 85vw !important;\r\n  }\r\n}\r\n}\r\n\r\n.messages-export-menu-wrap {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.messages-export-dropdown-panel {\r\n  position: fixed;\r\n  transform: translateX(-100%);\r\n  z-index: 1100;\r\n  width: 300px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  padding: 4px 0;\r\n\r\n  &.bulk-download-dropdown-panel {\r\n    width: 320px;\r\n  }\r\n\r\n  .bulk-download-chevron {\r\n    flex-shrink: 0;\r\n    font-size: 11px;\r\n    margin-left: auto;\r\n    opacity: 0.7;\r\n  }\r\n\r\n  .export-range-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    min-height: 40px;\r\n    padding: 0 16px;\r\n    cursor: default;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\r\n    margin-bottom: 4px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .export-range-label {\r\n    color: #17a2b8;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .export-range-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n    margin-left: 12px;\r\n  }\r\n\r\n  .export-range-value {\r\n    color: #212529;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    width: 96px;\r\n    text-align: right;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .export-range-nav-btn {\r\n    background: transparent;\r\n    border: none;\r\n    color: #17a2b8;\r\n    cursor: pointer;\r\n    padding: 2px 4px;\r\n    line-height: 1;\r\n    flex-shrink: 0;\r\n    width: 20px;\r\n    text-align: center;\r\n\r\n    &:disabled {\r\n      color: #c0c0c0;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    &:not(:disabled):hover {\r\n      color: #138496;\r\n    }\r\n  }\r\n}\r\n\r\n.messages-export-dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background: rgba(0, 0, 0, 0.04);\r\n    outline: none;\r\n  }\r\n\r\n  &.bulk-download-menu-row {\r\n    align-items: center;\r\n    display: flex;\r\n  }\r\n}\r\n\r\n// Bulk download section inside Export dropdown (pills + Download ZIP).\r\n.bulk-download-export-section {\r\n  padding: 4px 0 8px;\r\n}\r\n\r\n.bulk-download-export-divider {\r\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\r\n  margin: 4px 0 8px;\r\n}\r\n\r\n.bulk-download-export-title {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  gap: 8px;\r\n  justify-content: space-between;\r\n  padding: 0 16px 6px;\r\n}\r\n\r\n.bulk-download-count-badge {\r\n  border-radius: 12px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n}\r\n\r\n.bulk-download-count--ok {\r\n  background: #e8f5e9;\r\n  color: #2e7d32;\r\n}\r\n\r\n.bulk-download-count--none {\r\n  background: #f5f5f5;\r\n  color: #757575;\r\n}\r\n\r\n.bulk-download-count--over {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n}\r\n\r\n.bulk-download-limit-warning {\r\n  color: #c62828;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin: 0 16px 8px;\r\n}\r\n\r\n// Pill toggles for Input / Transformed / Both (replaces mat-checkbox row).\r\n.bulk-download-type-pills {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  padding: 0 16px 8px;\r\n}\r\n\r\n.bulk-download-pill {\r\n  background: #fff;\r\n  border: 1px solid #009688;\r\n  border-radius: 16px;\r\n  color: #009688;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  padding: 5px 14px;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n\r\n  &:hover {\r\n    background: rgba(0, 150, 136, 0.08);\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.bulk-download-pill--active {\r\n  background: #009688;\r\n  color: #fff;\r\n\r\n  &:hover {\r\n    background: #00796b;\r\n  }\r\n}\r\n\r\n.bulk-download-export-checkboxes {\r\n  padding: 0 16px 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.bulk-download-export-action {\r\n  font-weight: 600;\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
